import { Component, OnInit, AfterViewInit, OnDestroy, DestroyRef, inject } from "@angular/core";
import { RouterOutlet } from '@angular/router';
import { TranslateService } from "@ngx-translate/core";
import { InactivityService } from "@app/core/services/inactivity.service";
import { WorkingShiftService } from "@app/core/services/working-shift.service";
import { TooltipService } from "@app/shared/services/tooltip.service";
import { NavigationEnd, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { AuthService } from "@app/core/services/auth.service";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  private routerSubscription: Subscription = new Subscription();
  private readonly destroyRef = inject(DestroyRef);
  private readonly translate = inject(TranslateService);
  private readonly inactivityService = inject(InactivityService);
  private readonly workingShiftService = inject(WorkingShiftService);
  private readonly tooltipService = inject(TooltipService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  ngOnInit() {
    this.setLanguage();
    this.inactivityService.startInactivityWatch();
    this.observeAuthState();
    this.initializeTooltips();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.tooltipService.initializeAllTooltips();
    }, 100);
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
    this.tooltipService.disposeAllTooltips();
  }

  private observeAuthState(): void {
    this.authService.authState$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (isAuthenticated) => {
          if (isAuthenticated) {
            this.workingShiftService.getMinutesUntilEndOfWorkingShift();
          }
        },
      });
  }

  setLanguage() {

    if (!localStorage.getItem('currentLang')) {
      localStorage.setItem('currentLang', 'ru');
    }
    const currentLang = localStorage.getItem('currentLang') || 'ru';
    this.translate.setDefaultLang(currentLang);
  }

  initializeTooltips() {
    // Re-initialize tooltips on route changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.tooltipService.disposeAllTooltips();
        setTimeout(() => {
          this.tooltipService.initializeAllTooltips();
        }, 200);
      });
  }
}
